
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAACKUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/0WC/4Ks/5u8/3aj/1GK/7TN/////1GL/+bv//L3 /9rm/83d/+bu/12T/5y8/83e/8DV/4Or/5u9/4+0/4Kr/9nm/8HV/3Wj/4Os/2mb/wAAAAhdDx0A AAASdFJOUwBAj9/PnyAQkI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAAL EwEAmpwYAAAAB3RJTUUH5wwEAzkiVKWJywAAAP1JREFUKM99ku1WwyAMQGO3tptTpwFaAnTdum/1 /Z/PULUIp3h/9AC3SUoaAOahWGDEsqzgm3qFM6zr0S1xlkdvV5hhDVBhlg2UeVnAU9gIqVTThv0C gtI0ooOepLFErts5or5NpbG9pj0vpKVeJFKTxsNwHE5oHC8jabjYGQ/87PBCJCLZkNsPZ5T8URfh 6BpJRTsc6OTTH7Ejlcgb3n0tPb4VS0lOcC3Naa/o6D2SgmtxOqbHD6I2vYr7tF52jU2vgsLSxNSi qH2JCxLNb+PFdAR/Rss0Ssmg8Ble8j+7hE1e8nhmQwuevu1/ownb2dii/pn5qkyiX4s3f/4Fk5A5 RUyaIw4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTMrMDA6MDDwD6P2AAAA JXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEyLTA0VDAyOjMyOjEzKzAwOjAwgVIbSgAAACh0RVh0ZGF0 ZTp0aW1lc3RhbXAAMjAyMy0xMi0wNFQwMzo1NzozNCswMDowMILP2+QAAAAASUVORK5CYII="}})])
          )
        }
      }
    